import { SvgIcon } from '@mui/material'

export function MatchCaseIcon({ on }) {
  const colors = {
    stroke: on ? 'var(--clvn-blue-100)' : 'var(--clvn-blue-400)',
  }

  return (
    <SvgIcon viewBox="0 0 27 21" sx={{ width: '27px', height: '21px', fill: 'none' }}>
      {on ? (
        <rect width="27" height="21" rx="4" fill="#69C1FF" />
      ) : (
        <>
          <rect x="0.5" y="0.5" width="26" height="20" rx="3.5" fill="var(--clvn-blue-100)" />
          <rect x="0.5" y="0.5" width="26" height="20" rx="3.5" stroke="#A9C5D0" />
        </>
      )}
      <path
        d="M21.375 12.25H17"
        stroke={colors.stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 14V10.9375C17 10.3573 17.2305 9.80094 17.6407 9.3907C18.0509 8.98047 18.6073 8.75 19.1875 8.75C19.7677 8.75 20.3241 8.98047 20.7343 9.3907C21.1445 9.80094 21.375 10.3573 21.375 10.9375V14"
        stroke={colors.stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.9375 11.375H12.1875"
        stroke={colors.stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.625 14L9.5625 6.125L13.5 14"
        stroke={colors.stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}
